import { FOLDER_PATH_HEADER_NAME } from '@pages/monitoring/monitoring.interceptor';
import { of, Subject, } from 'rxjs';
import { map, share, takeUntil, tap, } from 'rxjs/operators';
var NameCacheService = /** @class */ (function () {
    function NameCacheService(_entityService) {
        this._entityService = _entityService;
        this._propertyName = 'name';
        this._cache = {};
        this._destroyed$ = new Subject();
    }
    NameCacheService.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    NameCacheService.prototype.get = function (id, _a) {
        var _b;
        var _this = this;
        var _c = _a === void 0 ? {} : _a, default$ = _c.default$, fqn = _c.fqn;
        if (this._cache[id] == null) {
            this._cache[id] = default$ || this._entityService
                .getInstance(id, null, (_b = {}, _b[FOLDER_PATH_HEADER_NAME] = fqn, _b))
                .pipe(tap(function (entity) { return _this.cacheEntity(entity); }), map(function (entity) { return "" + entity[_this._propertyName]; }), share(), takeUntil(this._destroyed$));
        }
        return this._cache[id];
    };
    NameCacheService.prototype.cacheEntity = function (entity) {
        this._cache[entity.id] = of("" + entity.name);
    };
    return NameCacheService;
}());
export { NameCacheService };
